import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getContractCooperationTypes } from 'modules/settings/api';

export const useQueryContractCooperationTypes = () => {
  //getContractCooperationTypes
  const {
    data: allCooperationTypes,
    isError: errContractCooperationTypes,
    isLoading: isLoadingContractCooperationTypes,
  } = useQuery(QUERY_KEYS.CONTRACT_COOPERATION_TYPES, getContractCooperationTypes);

  return {
    contractCooperationTypesData: allCooperationTypes?.data || {},
    isError: errContractCooperationTypes,
    isLoading: isLoadingContractCooperationTypes,
  };
};
